const styles = {
  outerBox: {
    width: '100%'
  },

  emptyStateBox: {
    background: '#F7F7F7',
    borderRadius: '8px',
    padding: '1.5rem',
    textAlign: 'center',
  },

  emptyStateText: {
    fontSize: '14px',
    color: '#707173',
  },

  totalAmountContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '0.5rem',
    marginRight: '1rem'
  },

  totalAmountLabel: {
    fontSize: '14px',
    color: '#010953',
    marginRight: '5px',
  },

  totalAmountValue: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#010953',
  },

  tableContainer: {
    '&.MuiTableContainer-root': {
      px: '6px',
      width: 'auto',
    },
  },

  table: {
    '&.MuiTable-root': {
      minWidth: '1046px',
    },
  },

  tableBody: {
    '&.MuiTableBody-root::before': {
      display: 'block',
      content: '""',
      height: '8px',
    },
  },

  tableHeadRow: {
    '&.MuiTableRow-root': {
      backgroundColor: '#F2F7F8',
      boxShadow: '0px 3px 6px #00000029',
    },
  },

  tableHeadCell: {
    '&.MuiTableCell-head': {
      pl: '1rem',
      pr: '1.33rem',
      py: '1rem',
    },
  },

  tableHeadCellForDateCreated: { width: '20%' },
  tableHeadCellForDescription: { width: '50%' },
  tableHeadCellForIneligibleAmount: { width: '24%' },
  tableHeadCellForAction: { width: '6%' },

  tableHeaderText: {
    '&.MuiFormLabel-root': {
      fontWeight: 'bold',
      fontSize: '14px',
      color: '#000000',
    },
  },

  asterisk: {
    color: '#DB3131',
  },

  tableRow: {
    '&.MuiTableRow-root': {
      verticalAlign: 'top',
      backgroundColor: '#FEFEFE',
    },
  },

  tableCell: {
    '&.MuiTableCell-root': {
      borderBottom: 'none',
      padding: '0.30rem 0.30rem 0 0rem',
      lineHeight: '21px',
    },
  },

  textField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      fontSize: '14px',
      backgroundColor: '#FFFFFF',
      borderRadius: '3px',
    },
    '& .MuiOutlinedInput-input': {
      padding: '0.5rem 0.75rem',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      margin: 0,
      lineHeight: '14px',
      paddingTop: '4px',
      color: '#D1062E',
    },
  },

  rightAlignedText: { textAlign: 'right' },
  centerAlignedText: { textAlign: 'center' },

  actionTableCell: {
    '&.MuiTableCell-root': {
      borderBottom: 'none',
      paddingTop: '0.30rem',
      paddingBottom: '0.30rem',
    },
  },

  actionButton: {
    paddingTop: '0.30rem',
    paddingBottom: '0.30rem',
  },

  buttonTabs: {
    paddingX: '6px',
    marginBottom: '10px',
    '.MuiTabs-flexContainer': {
      borderBottom: '1px solid #E5E2E2',
    },
  },

  hidden: {
    display: 'none',
  },
};

export default styles;
